
export const MessageTypeVariant = 'warning';

export const LanguageCodeVariant = 'secondary';

export const InternalLabelVariant = 'secondary';